import { useState } from "react";

import {
    crearDocumento,
    eliminarDocumento,
    obtenerDocumentos,
    descargarDocumento,
     obtenerDocumentosPublicos
} from "../Services/Documentos";

export const useDocumentos = () => {

    const [documentos, setDocumentos] = useState([]);
    const [documento, setDocumento] = useState(null);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);


    // ==========================================
    // OBTENER DOCUMENTOS
    // ==========================================

    const cargarDocumentos = async () => {

        try {

            setLoading(true);
            setError(null);

            const response = await obtenerDocumentos();


            const data = Array.isArray(response.data.documentos)
                ? response.data.documentos
                : [];

            setDocumentos(data);


            return data;

        } catch (error) {

            console.error(
                "Error al obtener documentos:",
                error
            );

            setError(error);

            setDocumentos([]);

            throw error;

        } finally {

            setLoading(false);

        }

    };


    // ==========================================
    // CREAR DOCUMENTO
    // ==========================================

    const guardarDocumento = async (formData) => {

        try {

            setLoading(true);
            setError(null);

            const response = await crearDocumento(formData);

            await cargarDocumentos();

            return response;

        } catch (error) {

            console.error(
                "Error al crear documento:",
                error
            );

            setError(error);

            throw error;

        } finally {

            setLoading(false);

        }

    };


    // ==========================================
    // ELIMINAR DOCUMENTO
    // ==========================================

    const borrarDocumento = async (id) => {

        try {

            setLoading(true);
            setError(null);

            const response = await eliminarDocumento(id);

            await cargarDocumentos();

            return response;

        } catch (error) {

            console.error(
                "Error al eliminar documento:",
                error
            );

            setError(error);

            throw error;

        } finally {

            setLoading(false);

        }

    };


    // ==========================================
    // DESCARGAR DOCUMENTO
    // ==========================================

    const descargar = async (id) => {

        try {

            setLoading(true);
            setError(null);

            const response = await descargarDocumento(id);

            return response;

        } catch (error) {

            console.error(
                "Error al descargar documento:",
                error
            );

            setError(error);

            throw error;

        } finally {

            setLoading(false);

        }

    };


    return {

        documentos,
        documento,

        loading,
        error,

        cargarDocumentos,
        guardarDocumento,
        borrarDocumento,
        descargar,

        setDocumento,

    };

};


export const useDocumentosPublicos = () => {

    const [documentos, setDocumentos] = useState([]);

    const [loading, setLoading] = useState(false);

    const [error, setError] = useState(null);


    // ==========================================
    // OBTENER DOCUMENTOS PÚBLICOS
    // ==========================================

   const cargarDocumentosPublicos = async () => {

        try {

            setLoading(true);
            setError(null);

            const response =
                await obtenerDocumentosPublicos();

            console.log(
                "Documentos públicos:",
                response.data
            );

            const data = Array.isArray(response.data.documentos)
                ? response.data.documentos
                : [];

            setDocumentos(data);

            return data;

        } catch (error) {

            console.error(
                "Error al obtener documentos públicos:",
                error
            );

            setError(error);
            setDocumentos([]);

            throw error;

        } finally {

            setLoading(false);

        }
    };


    return {
        documentos,
        loading,
        error,
        cargarDocumentosPublicos,
    };
};